import React, { useEffect, useState } from 'react';
import Autocomplete from '@material-ui/lab/Autocomplete';
import {
  TextField,
  Grid,
  FormControlLabel,
  FormControl,
  FormLabel,
  RadioGroup,
  Radio,
  FormGroup, Typography,
  Box,
  Switch
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import CheckIcon from '@material-ui/icons/Check';
import Rating from '@material-ui/lab/Rating';
import clsx from 'clsx';
import theme from '../../../theme';
import { getMetiersSearch } from '../../../Functions/Get-query/getMetiersSearch';
import { getJobRequirements } from '../../../Functions/Get-query/getJobRequirements';
import { getUserMetier } from '../../../Functions/Get-query/getUserMetier';
import useSessionContext from '../../../sessions/useSessionContext';

const useStyles = makeStyles((theme) => ({
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(4),
  },
  addButton: {
    minWidth: '50px',
    height: '50px',
    margin: theme.spacing(3, 0, 3),
    padding: 0,
  },
  reverseButtonStyle: {
    color: '#e5087e',
    backgroundColor: '#ffffff',
    borderRadius: '55px',
    border: 'none',
    boxShadow: '2px 2px 4px 0 rgba(0, 0, 0, 0.3)',

    '&:hover': {
      color: '#fff',
      backgroundColor: '#e5087e',
    },
    '&:focus, &.focus': {
      color: '#fff',
      backgroundColor: '#e5087e',
      boxShadow: '0 0 0 .2rem rgba(#FF1C96, 0.2)',
      borderWidth: 0,
    },
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      marginTop: '20px',
    },
  },
  buttonStyle: {
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      marginBottom: '20px',
    },
  },
  smallTitle: {
    fontFamily: ['Dosis', '"Helvetica Neue"', 'Arial', 'sans-serif'].join(','),
    textShadow: 'none',
    color: 'black',
    fontSize: '1.3rem',
    fontWeight: '500',
    margin: '2vh 0',
  },
  orLine: {
    position: 'relative',
    '&::before': {
      content: '""',
      position: 'abosolute',
      top: 0,
      left: 0,
      width: '100px',
      height: '1px',
      backgroundColor: '#000',
    },
  },
  error: {
    color: '#e5087e',
    fontFamily: ['Dosis', '"Helvetica Neue"', 'Arial', 'sans-serif'].join(','),
    marginTop: '3px',
    fontWeight: '500',
  },
  html: {
    height: '100%',
    margin: 0,
  },
  root: {
    display: 'block',
    margin: '2rem 0',
    width: '100%',
    '& span': {
      fontSize: '1.3rem',
      fontWeight: ' 300',
    },
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
  icon: {
    width: 16,
    height: 16,
    boxShadow:
      'inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)',
    backgroundColor: '#f5f8fa',
    backgroundImage: `${CheckIcon}`,
    'input:hover ~ &': {
      backgroundColor: '#ebf1f5',
    },
    'input:disabled ~ &': {
      boxShadow: 'none',
      background: 'rgba(206,217,224,.5)',
    },
  },
  checkedIcon: {
    backgroundColor: '#000',
    backgroundImage: `${CheckIcon}`,
    '&:before': {
      display: 'block',
      width: 16,
      height: 16,
      backgroundImage: `${CheckIcon}`,
      content: '""',
    },
    'input:hover ~ &': {
      backgroundColor: '#106ba3',
    },
  },
  radioLegend: {
    textAlign: 'left',
    fontSize: '1.15rem',
    fontWeight: '300',
    marginBottom: '2vh',
  },
  selectionLabel: {
    display: 'block',
    fontSize: '1.3rem',
    fontWeight: '600',
    marginBottom: '1rem',
  },
  fieldSetWrapper: {
    marginBottom: 24,
    borderRadius: 6,
  },
  listItemsContract: {
    fontFamily: ['Dosis', '"Helvetica Neue"', 'Arial', 'sans-serif'].join(','),
    textTransform: 'uppercase',
    fontSize: '1.3rem',
  },
  bold: {
    fontWeight: 600,
  }
}));

const starsLabel = ['0 à 2 ans', '2 à 5 ans', '5 à 7 ans', '7 à 10 ans', '+ de 10 ans'];

const parseFromElasticSearchResults = (results) => {
  const parsedJobsArray = [];
  results.forEach((res) => {
    parsedJobsArray.push({
      title: res._source.name,
      id: res._source.id,
    });
  });
  return parsedJobsArray;
};

// Inspired by blueprintjs
function StyledRadio(props) {
  const classes = useStyles(theme);
  return (
    <Radio
      disableRipple
      color="default"
      checkedIcon={<span className={clsx(classes.icon, classes.checkedIcon)} />}
      icon={<span className={classes.icon} />}
      {...props}
    />
  );
}

const ViewMetier = ({
  userType,
  jobLimit,
  metierId,
  userMetierId,
  metierName,
  viewProfile,
}) => {
  const classes = useStyles(theme);
  const [loading, setLoading] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [jobList, setJobList] = useState([]);
  const [selectedData, setSelectedData] = useState({});
  const [showNextSteps, setShowNextSteps] = useState(false);
  const [initialData, setInitialdata] = useState({});
  const [contractTypeList, setContractTypeList] = useState([]);
  const [contractTypeUserId, setContractTypeUserId] = useState(null);
  const [pendingContract, setPendingContract] = useState([]);
  const [candidatePersonalInformation, setCandidatePersonalInformation] = useState({
    project: '',
    availability: '',
    passportValid: '--',
    driverLicense: '--',
    age: null,
    candidateNationalities: [] ,
  });
  const [candidateLinks, setCandidateLinks] = useState({
    personalityTest: "",
    portfolioLink: "",
    linkedinLink: "",
    presentationLink: "",
  })
  const [employeeNumber, setEmployeeNumber] = useState('')
  const [candidateDesiredDestinations, setCandidateDesiredDestinations] = useState({})
  const { user } = useSessionContext();
  const [numberOfStars, setNumberOfStars] = useState({});
  const [userValues, setUserValues] = useState([]);
  const [commonValues, setCommonValues] = useState([]);
  const [matchPercentage, setMatchPercentage] = useState(0);



  function handleCheck(i, element) {
    let isChecked = false;
    if (Object.keys(initialData)[i] in selectedData) {
      if (selectedData[Object.keys(initialData)[i]].includes(element.id.toString())) {
        isChecked = true;
      }
    }
    return isChecked;
  }

  const renderCheckboxes = () => {
    const titleTrad = {
      generalEducation: 'Enseignement géréral',
      experienceLevels: 'Expérience de travail',
      specificEducation: 'Étude spécifique',
      workType: 'Type de travail ( Minimum 3 choix )' ,
      materialType: 'Outils de travail utilisés',
      otherSpecific: 'Autres spécifications',
    };

    return (
      Object.keys(initialData).map((key, index) => {
        if (initialData[Object.keys(initialData)[index]].length === 0) {
          return false;
        }
        return (
          <fieldset key={key} className={classes.fieldSetWrapper}>
            <legend className={classes.smallTitle}>
              {titleTrad[Object.keys(initialData)[index]]}
            </legend>
            <FormGroup>
              {initialData[Object.keys(initialData)[index]].map((element) => {
                if (handleCheck(index, element)) {
                  const numberOfStarsExists = (numberOfStars[element.label] == undefined || numberOfStars[element.label] == null ||
                    numberOfStars[element.label] == 0) ? false : true;
                  return (
                    <>
                      <FormControlLabel
                        key={element.id}
                        value={[Object.keys(initialData)[index], element.id, element.label]}
                        label={element.label}
                        control={<StyledRadio />}
                        checked
                      />
                      { handleCheck(index, element) && numberOfStarsExists && Object.keys(initialData)[index] != 'experienceLevels'
                        && Object.keys(initialData)[index] != 'generalEducation' && Object.keys(initialData)[index] != 'specificEducation' &&
                      <>
                        <Typography component="legend">Niveau d'expérience</Typography>
                        <Grid container>
                          <Grid item xs={6}>
                            <Box component="fieldset" mb={3} borderColor="transparent">
                              <Rating
                                name={element.label}
                                value={numberOfStars[element.label] ?? 0}
                                readOnly
                              />
                            </Box>
                          </Grid>
                            <Grid item xs={6}>
                                <Typography component="legend">{starsLabel[numberOfStars[element.label] - 1]}</Typography>
                            </Grid>
                        </Grid>
                      </>
                      }
                    </>
                  );
                }
                return false;
              })}
            </FormGroup>
          </fieldset>
        );
      })
    );
  };

  function createCheckBoxes() {
    const arraySelections = [];
    const titleTrad = {
      generalEducation: 'Enseignement géréral',
      experienceLevels: 'Expérience de travail',
      specificEducation: 'Étude spécifique',
      workType: 'Type de travail',
      materialType: 'Outils de travail utilisés',
      otherSpecific: 'Autres spécifications',
    };
    for (let i = 0, l = Object.keys(initialData).length; i < l; i += 1) {
      if (initialData[Object.keys(initialData)[i]].length === 0) {
        break;
      }
      const title = titleTrad[Object.keys(initialData)[i]];
      arraySelections.push(<FormControl>
        <FormLabel component="legend" className={classes.radioLegend} style={{ justifyContent: 'space-around' }} />
        <FormLabel component="legend" className={classes.radioLegend} style={{ justifyContent: 'space-around' }}>
          {title}
        </FormLabel>
      </FormControl>);
      initialData[Object.keys(initialData)[i]].forEach((element) => {
        let isChecked = false;
        if (Object.keys(initialData)[i] in selectedData) {
          if (selectedData[Object.keys(initialData)[i]].includes(element.id.toString())) {
            isChecked = true;
          }
        }
        { isChecked ? arraySelections.push(
            <FormControlLabel
              value={[Object.keys(initialData)[i], element.id, element.label]}
              label={element.label}
              control={<StyledRadio />}
              checked={isChecked}
            />,
          ) : null;
        }
      });
    }

    if (!Array.isArray(selectedData.generalEducation)) {
      selectedData.generalEducation = [selectedData.generalEducation]
    }

    selectedData.generalEducation = selectedData.generalEducation.filter(x => x !== null)

    return (
        <div className={classes.root}>
          <FormLabel className={classes.selectionLabel}>
            {viewProfile || 'Sélections des informations relative au métier'}
          </FormLabel>
          {user.type_of_user == "Enterprise" && selectedData.generalEducation.length==0 ?  (
            <Typography  variant="caption" className={classes.selectionLabel}>
              La fiche métier n'est pas encore complète
            </Typography>
          ) : null}

          {user.type_of_user == "Candidate" && selectedData.generalEducation.length==0 ? (
            <Typography variant="caption" className={classes.selectionLabel}>
              L'entreprise n'a pas encore complété la fiche métier
            </Typography>
          ) : null}
         
          <RadioGroup
            required
            id="id"
            defaultValue=""
            aria-label="Experience"
            name="customized-radios"
          >
            {renderCheckboxes()}
          </RadioGroup>
        </div>
      );
  }

  const totalList = contractTypeList.map((contract) => {
    return (<li key={contract.id} className={classes.listItemsContract}>{contract.label}</li>);
  });

  const personalInformationList = (
    <>
      <li className={classes.listItemsContract}>Projet: <span className={classes.bold}>{candidatePersonalInformation.project}</span></li>
      <li className={classes.listItemsContract}>Passport valide (+ de 6 mois): <span className={classes.bold}>{candidatePersonalInformation.passportValid!= null ? (candidatePersonalInformation.passportValid ? 'Oui' : 'Non'): '--'}</span></li>
      <li className={classes.listItemsContract}>Disponibilité: <span className={classes.bold}>{candidatePersonalInformation.availability}</span></li>
      <li className={classes.listItemsContract}>Permis de conduire: <span className={classes.bold}>{candidatePersonalInformation.driverLicense}</span></li>
      <li className={classes.listItemsContract}>Nationalités: </li>
      {candidatePersonalInformation.candidateNationalities.map((nationality)=>(
        <Typography key={nationality}>{nationality}</Typography>
        ))
      }
    </>
  );

  const candidateListOfLinks = () => {
    if (user.type_of_user != 'Candidate' && viewProfile && user.is_subscribed === false || user.is_subscribed === null) {
      return (
        <>
          <li className={classes.listItemsContract}>Résultat du test de personnalité: <a
            href={candidateLinks.personalityTest} target= "_blank"
            className={classes.bold}>{candidateLinks.personalityTest}</a></li>
        </>
      )
    } else {
      return (
        <>
          <li className={classes.listItemsContract}>Résultat du test de personnalité:
            <a href={candidateLinks.personalityTest} target= "_blank"
            className={classes.bold}>{candidateLinks.personalityTest}</a></li>
          <li className={classes.listItemsContract}>Lien vers le portfolio:
            <a href={candidateLinks.portfolioLink} target= "_blank"
            className={classes.bold}>{candidateLinks.portfolioLink}</a></li>
          <li className={classes.listItemsContract}>Lien du profil LinkedIn:
            <a href={candidateLinks.linkedinLink} target= "_blank"
            className={classes.bold}>{candidateLinks.linkedinLink}</a></li>
          <li className={classes.listItemsContract}>Lien vers une vidéo de présentation:
            <a href={candidateLinks.presentationLink} target= "_blank"
            className={classes.bold}>{candidateLinks.presentationLink}</a>
          </li>
        </>
      )
    }
  };

    const renderCandidateDesiredDestinations = Object.entries(candidateDesiredDestinations).map(([key, value])=> {
      return(
        <li key={key} className={classes.listItemsContract}>{key} &#44; &#160; {value} </li>
      )
    })

  const enterpriseInformationList = (
    <>
      <li className={classes.listItemsContract}>Nombre d'employés: <span className={classes.bold}>{employeeNumber}</span></li>
    </>
  );

  const userValuesList = userValues.map(value => {
    const isCommonValue = commonValues.includes(value);

    if (isCommonValue) {
      return  <li key={value} className={classes.listItemsContract}><span className={classes.bold}>{value}</span></li>
    }
    return <li key={value} className={classes.listItemsContract}>{value}</li>
  }
  );

  const handleJobs = () => {
    getUserMetier(userMetierId).then((userMetierData) => {
      
      setUserValues(userMetierData.userValues ?? []);
      setCommonValues(userMetierData.commonValues ?? []);
      setEmployeeNumber(userMetierData.employeeCount)
      setNumberOfStars(userMetierData.numberOfStars);
      setMatchPercentage(userMetierData.matchPercentage);
      setCandidateDesiredDestinations(userMetierData.candidateDesiredDestinations);
      getJobRequirements(metierId).then((response) => {
        let generalEducationList = [];
        let experienceLevelsList = [];
        let specificEducationList = [];
        let workTypeList = [];
        let materialTypeList = [];
        let otherSpecificList = [];

        if (response.total > 0) {
          experienceLevelsList = response.results.ExperienceLevels;
          generalEducationList = response.results.GeneralEducation;
          specificEducationList = response.results.SpecificEducation;
          workTypeList = response.results.WorkType;
          materialTypeList = response.results.MaterialType;
          otherSpecificList = response.results.OtherSpecific;
        }
        setContractTypeList(userMetierData.contractTypes ?? [])
        setContractTypeUserId(userMetierData.userId)
        setSelectedData(userMetierData ?? {});
        setInitialdata({
          experienceLevels: experienceLevelsList,
          generalEducation: generalEducationList,
          specificEducation: specificEducationList,
          workType: workTypeList,
          materialType: materialTypeList,
          otherSpecific: otherSpecificList,
        });
        setCandidatePersonalInformation((candidatePersonalInformation) => ({
          ...candidatePersonalInformation,
          project: userMetierData.project,
          availability: userMetierData.availability,
          passportValid: userMetierData.passportValid,
          driverLicense: userMetierData.driverLicense ?? '--',
          candidateNationalities: userMetierData.candidateNationalities ?? [],
        }));

        setCandidateLinks((candidateLinks) => ({
          ...candidateLinks,
          personalityTest: userMetierData.candidateLinks[0],
          portfolioLink: userMetierData.candidateLinks[1],
          linkedinLink: userMetierData.candidateLinks[2],
          presentationLink: userMetierData.candidateLinks[3],
        }));
        setShowNextSteps(true);
      });
    });
  };
  useEffect(() => {
    handleJobs();
  }, []);

  const onTextChanged = (event) => {
    if (!loading) {
      setLoading(true);
      const query = event.target.value;
      if (query === null) {
        setJobList([]);
        setIsOpen(false);
      } else {
        getMetiersSearch(query).then((result) => {
          if (result.total > 0) {
            const parsedRes = parseFromElasticSearchResults(result.results);
            setJobList(parsedRes);
            setIsOpen(true);
          }
          setLoading(false);
        });
      }
    }
  };
  return (
    <>
      <Grid item xs={12}>
        <Autocomplete
          multiple={jobLimit != 1}
          onOpen={onTextChanged}
          onClose={() => setJobList([])}
          limitTags={jobLimit || 3}
          name="jobs"
          id="jobs"
          loading={loading}
          options={jobList}
          getOptionLabel={(option) => option.title}
          key={(option) => option.id}
          disabled
          renderInput={(params) => (
            <TextField
              {...params}
              onChange={onTextChanged}
              variant="outlined"
              label={metierName}
              placeholder="Emploi"
            />
          )}
        />
        <>{showNextSteps && createCheckBoxes()}</>
        { contractTypeUserId !== user.id &&
        <fieldset className={classes.fieldSetWrapper}>
          <FormLabel component="legend" className={classes.smallTitle} style={{ justifyContent: 'space-around' }}>
            {"Type(s) de Contrat(s)"}
          </FormLabel>
            {totalList}
        </fieldset>
        }
        { user.type_of_user != 'Candidate'  && viewProfile &&
          <fieldset className={classes.fieldSetWrapper}>
            <FormLabel component="legend" className={classes.smallTitle} style={{ justifyContent: 'space-around' }}>
              {"Destinations souhaitées"}
            </FormLabel>
            {renderCandidateDesiredDestinations}
          </fieldset>
        }
        { user.type_of_user != 'Candidate'  && viewProfile &&
          <fieldset className={classes.fieldSetWrapper}>
            <FormLabel component="legend" className={classes.smallTitle} style={{ justifyContent: 'space-around' }}>
              {"Informations personnelles"}
            </FormLabel>
              {personalInformationList}
          </fieldset>
        }

        { user.type_of_user != 'Candidate'  && viewProfile &&
        <fieldset className={classes.fieldSetWrapper}>
          <FormLabel component="legend" className={classes.smallTitle} style={{ justifyContent: 'space-around' }}>
            {"Personnalitée et Médias Sociaux du Candidat"}
          </FormLabel>
          {candidateListOfLinks()}
        </fieldset>
        }

        { user.type_of_user != 'Enterprise'  && viewProfile &&
        <fieldset className={classes.fieldSetWrapper}>
          <FormLabel component="legend" className={classes.smallTitle} style={{ justifyContent: 'space-around' }}>
            {"Informations de l'Entreprise"}
          </FormLabel>
          {enterpriseInformationList}
        </fieldset>
        }

        { user.type_of_user != 'Partner'  && userValues.length > 0 &&
          <fieldset className={classes.fieldSetWrapper}>
            <FormLabel component="legend" className={classes.smallTitle} style={{ justifyContent: 'space-around' }}>
            { viewProfile ?  `Découvrez les valeurs ${user.type_of_user === 'Candidate' ? 'de l’entreprise' : 'du candidat(e)'} ainsi que vos valeurs communes en gras.`
              :`Les valeurs que vous avez choisies pour votre ${user.type_of_user === 'Candidate' ? 'profil' : 'organisation'}`}
            </FormLabel>
            {userValuesList}
          </fieldset>
        }

        { user.type_of_user != 'Partner'  && matchPercentage >= 50 &&
          <fieldset className={classes.fieldSetWrapper}>
            <FormLabel component="legend" className={classes.smallTitle} style={{ justifyContent: 'space-around' }}>
             Pourcentage de correspondance aux compétences
            </FormLabel>
            <>
              <li className={classes.listItemsContract}>{`${matchPercentage}%`}</li>
            </>
            
          </fieldset>
        }
      </Grid>

    </>
  );
};

export default ViewMetier;
